// src/components/PostHogIdentify.tsx
import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';

export function PostHogIdentify() {
  const posthog = usePostHog();
  const { currentUser, isAuthenticated, isLoading } = useAuth();
  const identifiedRef = useRef<string | null>(null);

  useEffect(() => {
    if (
      posthog &&
      isAuthenticated &&
      !isLoading &&
      currentUser &&
      identifiedRef.current !== currentUser.id
    ) {
      posthog.identify(currentUser.id, {
        email: currentUser.email,
        role: currentUser.role,
        userType: currentUser.userType,
        accountId: currentUser.accountId,
        accountDisplayName: currentUser.account?.displayName,
        accountName: currentUser.account?.name
      });

      identifiedRef.current = currentUser.id;
    }
  }, [posthog, isAuthenticated, isLoading, currentUser]);

  return null;
}
